const expForm = [
  {
    id: "experience",
    titre: "Expérience",
    contenus: [
      {
        type: "experience",
        intitule: "Stagiaire en développement web",
        location: "Riopel Consultant, Saint-Jérôme",
        annee: "Novembre 2023 - Janvier 2024",
        resume: "J'ai travaillé sur le développement du portail web pour les employés de la compagnie en ajoutant un calendrier affichant leurs journées sur appels, en rédigeant de nouveaux scripts pour attribuer de nouvelles journées sur appels ou générer des rapports statistiques grâce à des données extraites d'une API, ainsi que l'envoi de courriels aux employés."
      },
      {
        type: "experience",
        intitule: "Chargé à l'approvisionnement",
        location: "Zone Maison (bureau), Montréal",
        annee: "Octobre 2020 - Octobre 2022",
        resume: "J'avais la charge des commandes et de la gestion des retours avec négociation de rabais sur les produits auprès des fournisseurs francophones et anglophones, ainsi que de la revente des produits endommagés. Je faisais aussi partie de l'équipe web et étais en charge de prendre les photos des produits, retoucher les photos et les mettre en ligne en suivant le protocole de référencement (SEO) mis en place."
      },
      {
        type: "experience",
        intitule: "Responsable de plancher",
        location: "Zone Maison (magasin), Montréal",
        annee: "Septembre 2019 - Octobre 2020",
        resume: "En tant que responsable de plancher, j'avais la responsabilité d'ouvrir et de fermer le magasin, de répartir les horaires des employés dans la journée, de gérer les cas clients ainsi que le comptage et la balance des caisses."
      }
    ]
  },
  {
    id: "formation",
    titre: "Formation",
    contenus: [
      {
        type: "formation",
        intitule: "AEC Développement logiciel & web",
        location: "Collège de Maisonneuve, Montréal",
        annee: "Octobre 2022 - Janvier 2024",
        resume: ""
      },
      {
        type: "formation",
        intitule: "DESS Design intérieur",
        location: "Université de Montréal, Montréal",
        annee: "Septembre 2018 - Juin 2019",
        resume: ""
      },
      {
        type: "formation",
        intitule: "Diplôme en Design intérieur",
        location: "CREAD, Lyon, France",
        annee: "Septembre 2010 - Juillet 2014",
        resume: ""
      }
    ]
  }
];

export default expForm;